"use client";
import AboutUs from "@/components/subComponents/aboutUs";

export default function ContactPage() {
  return <AboutUs />;
}
